import React, { FC, ReactElement, memo } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
// Components
import { clsx } from 'clsx';
import Text from '../text';
import SvgIcon from '../icons/SvgIcon';
import RadioButtonGroup from '../form/radioGroup';
// Resources
import { PickerOption } from '../../core/apiTypes';
import { IconAxel, IconCommon } from '../../resources/images';
import useGlobalStyles from '../hook/useGlobalStyles';

interface ListItemWithRadioProps {
    data: any;
    icon: IconAxel | IconCommon;
    title: string;
    subtitle?: JSX.Element;
    onSelect: (data: any) => void;
    isSelected?: boolean;
}

const ListItemWithRadio: FC<ListItemWithRadioProps> = (props): ReactElement => {
    const { data, icon, title, subtitle, isSelected, onSelect } = props;
    const classes = useStyles();
    const globalClasses = useGlobalStyles();

    const radioOptions: PickerOption[] = [{ value: '1', label: '' }];

    const onSelectLine = () => {
        onSelect(data);
    };

    return (
        <div className={classes.listItemWithRadioItemContainer}>
            <ListItem
                className={clsx(classes.listItemWithRadioItem, isSelected && classes.listItemWithRadioItemSelected)}
                button
                onClick={onSelectLine}
            >
                <ListItemIcon className={classes.icon}>
                    <SvgIcon icon={icon} color="black" fill="none" />
                </ListItemIcon>
                <ListItemText
                    primary={
                        <Text.ShortRegularText16
                            text={title}
                            customColor="black"
                            className={globalClasses.textOverflowWrap}
                        />
                    }
                    secondary={subtitle}
                    secondaryTypographyProps={{ component: 'span' }}
                />
                <RadioButtonGroup
                    title=""
                    color="secondary"
                    name="selector"
                    options={radioOptions}
                    value={Number(isSelected)}
                />

                {/* {isSelected && (
                    <ListItemIcon className={classes.icon}>
                        <SvgIcon icon={IconCommon.Check} stroke="none" width={18} height={18} />
                    </ListItemIcon>
                )} */}
            </ListItem>
        </div>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        listItemWithRadioItemContainer: {
            display: 'flex',
            justifyContent: 'center',
        },
        listItemWithRadioItem: {
            '&:hover': {
                borderColor: theme.palette.primary.main,
                backgroundColor: 'unset',
            },
            gap: 10,
            borderRadius: 10,
            padding: `12px 16px`,
            border: `1px solid ${theme.palette.colors.background.menuSeparator}`,
            '& .MuiRadio-root': {
                '&:hover': {
                    backgroundColor: 'unset',
                },
            },
            '& .MuiFormControlLabel-root': {
                marginRight: 0,
                '& > span': {
                    padding: 0,
                    color: theme.palette.secondary.main,
                },
            },
        },
        listItemWithRadioItemSelected: {
            borderColor: theme.palette.secondary.main + ' !important',
        },
        icon: {
            minWidth: 'unset',
        },
    }),
);

export default memo(ListItemWithRadio);
